import declare from	"dojo/_base/declare";
import CsiFormData from "csi/action/FormData";
import comm from "csi/comm";
import New from	"csi/table/New";
import xml from	"csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import PostRequest from "csi/comm/PostRequest";

const NewFormulatedMaterialSpecial = declare([New], {
	urlRecipeLineItem: null,

	/**
     * @override
     * return RecipeLineItem: as a new node
     */
	getNewNodes: function() {
		const node = this.m_cache.getNode(this.urlRecipeLineItem);
		return node ? [node] : null;
	},

	/**
     * @override
     * Add RecipeLineItem url to request
     */
	toWriterRequest(fd: CsiFormData): CallMethod{
		const call = this.inherited<CallMethod>(arguments);
		this.urlRecipeLineItem = comm.createUrl();
		const recipeSubtype = this.m_formData.getFieldValue("RecipeDataSheet/Subtype", true);
		call.addParameter("RecipeLineItemURL", xml.ATTR_REF, this.urlRecipeLineItem);
		call.addParameter("RecipeSubtype", xml.ATTR_REF, recipeSubtype);
		return call;
	},

	/**
     * @override
     * Add RecipeLineItem url to Return Nodes
     */
	getReturnNodeRequest(urlsNew: string[]): PostRequest{
		urlsNew.push(this.urlRecipeLineItem);
		return this.inherited<PostRequest>(arguments);
	},
    
	/**
     * @override
     * Disable Save & Go since action
     */
	_canNavigate: function() {
		return false;
	},

});

export = NewFormulatedMaterialSpecial;